import { FC } from 'react'
import cn from 'classnames'
import { useActions } from 'hooks'

import { DropdownActionsProps } from './types'

import s from './styles.module.less'

const DropdownActions: FC<DropdownActionsProps> = (props) => {
  const {
    isOrder,
    onClose,
    onCancelButtonClick,
    deleteButton,
    onDeleteButtonClick,
    updateButton,
    onUpdateButtonClick
  } = props
  const { closeMobileSidebar } = useActions()

  const handleDeleteContact = (e: React.SyntheticEvent) => {
    closeMobileSidebar()
    e.stopPropagation()
    onClose()

    setTimeout(() => {
      onDeleteButtonClick && onDeleteButtonClick(e)
    }, 0)
  }

  const handleUpdateContact = (e: React.SyntheticEvent) => {
    closeMobileSidebar()
    e.stopPropagation()
    onClose()

    setTimeout(() => {
      onUpdateButtonClick && onUpdateButtonClick(e)
    }, 0)
  }

  const handleCancelOrder = (e: React.SyntheticEvent) => {
    closeMobileSidebar()
    e.stopPropagation()
    onClose()

    setTimeout(() => {
      onCancelButtonClick && onCancelButtonClick(e)
    }, 0)
  }

  return (
    <div className={cn(s.menu, { [s.menu__half]: isOrder })}>
      {updateButton && (
        <div className={s.edit} onClick={handleUpdateContact}>
          {updateButton} <span className={s.editButtonText}>Редактировать</span>
        </div>
      )}
      {updateButton && deleteButton && <hr className={s.line} />}
      {deleteButton && (
        <div className={s.delete} onClick={handleDeleteContact}>
          {deleteButton} <span className={s.deteleButtonText}>Удалить контакт</span>
        </div>
      )}
      {isOrder && (
        <div className={s.delete} onClick={handleCancelOrder}>
          <span className={s.deteleButtonText}>Отменить заявку</span>
        </div>
      )}
    </div>
  )
}

export default DropdownActions
